import { makeStyles } from "@saleor/macaw-ui";

export const useStyles = makeStyles(
  theme => ({
    root: {
      overflowX: "auto",
      width: "100%",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: 6,
      marginTop: 24,
      marginBottom: 20,
      maxHeight: 500,
      "&::-webkit-scrollbar": {
        width: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        width: "6px"
      }
    },
    tableProduct: {
      marginTop: 30,
      marginBottom: "10rem"
    },
    mainTable: {
      borderCollapse: "collapse",
      "& .MuiTableCell-head > div > div": {
        color: theme.palette.grey[600]
      },
      "& .MuiTableRow-root": {
        background: "#FFF",
        "&:hover": {
          background: "#FFF !important"
        },
        "&:nth-child(even)": {
          background: "#FFF"
        }
      },
      "& .MuiFormControl-root": {
        height: 34
      }
    },
    tableTitle: {
      marginTop: 55,
      marginBottom: 20,
      display: "flex",
      alignItems: "center",
      height: 50
    },
    btn: {
      fontSize: 18
    },

    cellBackground: {
      "&&&": {
        background: theme.palette.grey[200],
        color: theme.palette.grey[600]
      },
      "& .MuiSvgIcon-root": {
        color: theme.palette.success.light
      }
    },
    tableRow: {
      borderTop: "2px solid white"
    },
    table: {
      borderCollapse: "collapse"
    },
    customerName: {
      color: theme.palette.grey[900]
    },
    colNumber: {
      color: theme.palette.grey[900]
    },
    colProductName: {
      color: theme.palette.grey[900]
    },
    cellBackGround: {
      background: `${theme.palette.grey[200]} !important`
    },
    normalText: {
      fontWeight: 700,
      color: theme.palette.grey[600]
    },
    lastCol: {
      paddingRight: "24px !important"
    },
    name: {
      color: theme.palette.grey[900],
      fontWeight: "bold"
    },
    subtitle: {
      fontWeight: 400
    },
    paginationWrapper: {
      marginTop: 16
    },
    wrapper: {
      maxHeight: 720,
      height: "100%",
      background: theme.palette.background.default,
      padding: "2.4rem 4rem",
      boxShadow: "0px -8px 24px rgba(0, 0, 0, 0.08)",
      borderTopLeftRadius: 32,
      borderTopRightRadius: 32,
      color: theme.palette.grey[900]
    },
    titleWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    headerClose: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      "& button": {
        background: "none",
        border: "none",
        padding: 0,
        display: "inline-flex",
        marginLeft: 12
      }
    },
    title: {
      color: theme.palette.info.dark
    },
    gridTitle: {
      marginTop: "1.6rem"
    },
    btnContainer: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: "auto",
      alignItems: "center"
    },
    rightContainer: {
      "& button": {
        minWidth: 270,

        "&:first-child": {
          marginRight: 24
        }
      }
    },
    error: {
      color: theme.palette.error.light,
      fontSize: "1.2rem",
      lineHeight: "1.8rem",
      marginTop: 6
    }
  }),
  { name: "CartDetailTable" }
);
